function About() {

  return (

    <div style={{padding:"80px"}}>

       <div className="w-1/2  hidden lg:block">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            AVYB Educational Management System
          </h2>

          <p className="text-gray-600 leading-relaxed text-lg">
            AVYB is a modern cloud-based management platform
            designed to simplify academic operations, attendance tracking,
            finance management, examinations, and communication between
            teachers, students, and parents.
          </p>

          <ul className="mt-6 space-y-3 text-gray-600">
            <li>✔ Role-based Dashboards</li>
            <li>✔ Attendance & Reports</li>
            <li>✔ Fee & Finance Management</li>
            <li>✔ Examination & Results</li>
            <li>✔ Communication System</li>
          </ul>
        </div>

    </div>

  );
}

export default About;